import React from 'react';

const SubmodeSelector = ({ 
  displaySubmode, 
  switchSubmode, 
  handleImportClick, 
  importError, 
  fileInputRef, 
  handleFileChange,
  submodes 
}) => {
  return (
    <>
      <div className="setup-submode-selector">
        {Object.values(submodes).map(mode => (
          <button 
            key={mode}
            className={`submode-btn ${displaySubmode === mode ? 'active' : ''}`}
            onClick={() => switchSubmode(mode)}
          >
            {mode}
          </button>
        ))}
        <button 
          type="button" 
          className="submode-btn load-btn"
          onClick={handleImportClick}
        >
          Load Points
        </button>
        
        {/* Hidden file input */}
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          accept=".json,.geojson,.csv"
          onChange={handleFileChange}
        />
      </div>
      
      {/* Import error message */}
      {importError && (
        <div className="error-message">
          Import Error: {importError}
        </div>
      )}
    </>
  );
};

export default SubmodeSelector; 